const config = {
  baseUrl: "/",
  apiUrl: process.env.REACT_APP_API_URL || ""
};

export default config;
